const navTabsSettings = {
    centerOnLoadToActiveElement: true,
    nextTabActiveOnPagination: true
};

initNavTabs(navTabsSettings);

function initNavTabs(customSettings) {
    document.addEventListener("DOMContentLoaded", () => {
        const SETTINGS = {
            navTabsParentClass: ".nav-tabs",
            navTabsTravelling: false,
            navTabsTravelDirection: "",
            navTabsTravelDistance: 150,
            navTabsIndicatorColor: "#00A3E0",
            centerOnLoadToActiveElement: false,
            nextTabActiveOnPagination: false,
            showTabIndicator: false,
            scrollSpeed: 2
        };

        Object.assign(SETTINGS, customSettings);

        const navTabs = document.querySelector(SETTINGS.navTabsParentClass);
        const navTabsItems = navTabs.querySelector(".nav-tabs-items");
        let activeTab = navTabs.querySelector(".tabs-item.active");
        const arrowLeft = navTabs.querySelector(".nav-tabs-arrow-left");
        const arrowRight = navTabs.querySelector(".nav-tabs-arrow-right");

        if (SETTINGS.centerOnLoadToActiveElement && activeTab) {
            document.querySelectorAll(SETTINGS.navTabsParentClass + " .tabs-item").forEach(item => {
                const elemWidth = item.offsetWidth;
                if (elemWidth > SETTINGS.navTabsTravelDistance) {
                    SETTINGS.navTabsTravelDistance = elemWidth;
                }
            });
            document.querySelectorAll(SETTINGS.navTabsParentClass + " .tabs-item").forEach(item => {
                item.style.width = SETTINGS.navTabsTravelDistance + "px";
            });
            centerOnLoadToActiveElement(activeTab);
        }

        function centerOnLoadToActiveElement(activeTab) {
            if (activeTab) {
                const scrollWidth = navTabsItems.scrollWidth;
                navTabsItems.scrollLeft = scrollWidth / 2 - navTabsItems.clientWidth / 2;
            }
        }

        function setScrollClasses() {
            navTabs.classList.remove("scroll-both", "scroll-left", "scroll-right");
            navTabs.classList.add(checkScrollAvailability());
        }

        function checkScrollAvailability() {
            const scrollWidth = navTabsItems.scrollWidth;
            const scrollElemWidth = navTabsItems.clientWidth;
            const currentScrollPos = navTabsItems.scrollLeft;

            if (currentScrollPos > 0 && scrollWidth > 0) {
                return "scroll-both";
            } else if (currentScrollPos === 0 && scrollWidth > scrollElemWidth) {
                return "scroll-right";
            } else if (currentScrollPos + scrollElemWidth === scrollWidth && scrollWidth > scrollElemWidth) {
                return "scroll-left";
            }
        }

        navTabsItems.addEventListener("scroll", setScrollClasses);
        window.addEventListener("resize", setScrollClasses);

        arrowLeft.addEventListener("click", () => {
            navTabsItems.style.scrollBehavior = "smooth";
            navTabsItems.scrollLeft = Math.max(navTabsItems.scrollLeft - SETTINGS.navTabsTravelDistance, 0);
            navTabsItems.style.scrollBehavior = "auto";
        });

        arrowRight.addEventListener("click", () => {
            navTabsItems.style.scrollBehavior = "smooth";
            navTabsItems.scrollLeft = Math.min(navTabsItems.scrollLeft + SETTINGS.navTabsTravelDistance, navTabsItems.scrollWidth);
            navTabsItems.style.scrollBehavior = "auto";
        });

        document.querySelectorAll(SETTINGS.navTabsParentClass + " .tabs-item").forEach(tab => {
            tab.addEventListener("click", () => {
                document.querySelectorAll(SETTINGS.navTabsParentClass + " .tabs-item").forEach(item => item.classList.remove("active"));
                tab.classList.add("active");
                activeTab = tab;
                setScrollClasses();
            });
        });
    });
}
